/**
 * @file SignupController
 * @description
 * Load into your application like `myApp.controller('SignupController', require('SignupController.js'))`
 */
module.exports = [
    '$scope',
    'CTHashService',
    'DataService',
    'ChannelRepository',
    'AppConstants',
    'CommitmentModel',
    '$q',
    'CTServiceAPI',
    'CTServiceAPIConfig',
    'EventTracker',
    '$sce',
    function($scope,
        CTHashService,
        DataService,
        ChannelRepository,
        AppConstants,
        CommitmentModel,
        $q,
        CTServiceAPI,
        CTServiceAPIConfig,
        EventTracker,
        $sce
    ) {
        const _controller = this,
            _channel = ChannelRepository.get(AppConstants.CHANNEL_SUBMISSION.NAME),
            _SMChannel = ChannelRepository.get(AppConstants.CHANNEL_SOCIALMEDIA.NAME),
            STEPS = {
                PERSON: 0,
                IMAGE: 1,
                STATEMENT: 2,
                TAGS: 3,
                FINISH: 4
            };

        let _step = STEPS.PERSON,
            _networkActivity = false;


        _controller.STEPS = STEPS;
        _controller.getStep = () => _step;

        // Sync the optin_pending flag with the DataService-flag
        Object.defineProperty(_controller, 'optin_pending', {
            get() {
                return DataService.optin_pending;
            }
        });
        _controller.sendCurrentStep = () => {
            const submit = () => _controller.submit()
                .then((data) => {

                    // after the first step, track an action
                    if (_controller.getStep() == STEPS.PERSON) {
                        EventTracker.track([
                            'Cambuildr',
                            'Auf Commitment-Seite eingetragen'
                        ]);
                    }

            // Overwrite data Object, but we must check, if we have already accepted the disclaimer.
            _controller.data = Object.assign({}, {
                id: data.id,
                show_public: true,
                person: {
                    name: data.person.name,
                    surname: data.person.surname,
                    email: _controller.data.person.email,
                    tags: data.person.tags,
                },
                message: data.message,
                image_id: data.image_id,
                image: data.image,
            }, (typeof _controller.data.disclaimer_accepted !==
                'undefined') ? { disclaimer_accepted: _controller.data.disclaimer_accepted } : {});

                    setNextStep();
                });

            // if we arent in the first signup step, send the amend_request param
            if (_controller.getStep() !== STEPS.PERSON) {
                _controller.data.amend_request = true;
            }

            if (_controller.getStep() == STEPS.IMAGE) {
                _controller.mediaDrop.submitMedia()
                    .then(submit);
            }
            else {
                submit();
            }
        };

        _controller.skipCurrentStep = () => setNextStep();

        function setNextStep() {
            switch (_controller.getStep()) {
                case STEPS.PERSON:
                    initStep(STEPS.IMAGE);
                    break;
                case STEPS.IMAGE:
                    initStep(STEPS.STATEMENT);
                    break;
                case STEPS.STATEMENT:
                    initStep(STEPS.TAGS);
                    break;
                case STEPS.TAGS:
                    initStep(STEPS.FINISH);
                    break;
            }
        }


        /**
         * Set network activity when flag is defined
         * Get when flag is not defined
         *
         * @param {boolean} [flag]
         */
        _controller.hasNetworkActivity = (flag) => {
            if (flag === true || flag === false) {
                return (_networkActivity = flag);
            }
            else {
                return _networkActivity;
            }
        };

        /**
         * Initialize disclaimer_accepted only when config Value is set
         * @param val
         */
        _controller.setDisclaimerAccepted = function(val) {
            // AppConstants.ACCEPT_DISCLAIMER_ENABLED set in index.blade.php
            if (AppConstants.ACCEPT_DISCLAIMER_ENABLED) {
                _controller.data.disclaimer_accepted = val;
            }
        };


        /**
         * replace the placeholders %vorname% and %nachname% by the data from the first step.
         *
         * @param text
         * @returns {XML|string}
         */
        _controller.parsePlaceholders = function(text) {
            return $sce.trustAsHtml(text.replace(new RegExp('%vorname%', 'g'), _controller.data.person.name)
                .replace(new RegExp('%nachname%', 'g'), _controller.data.person.surname));
        };


        /**
         * Check if the signup form should be opened
         */
        _controller.isOpen = () => !!CTHashService.get('einsenden');


        /**
         * Reset all data
         */
        _controller.reset = () => {
            _controller.data = {
                show_public: true,
                person: {}
            };

            _controller.setDisclaimerAccepted(false);


            _controller.hasFbEmail = false;

            if (_controller.mediaDrop && _controller.mediaDrop.removeMedia) {
                _controller.mediaDrop.removeMedia();
            }

            _step = STEPS.PERSON;

            _channel.notify(AppConstants.CHANNEL_SUBMISSION.ACTION_RESET);
        };

        /**
         * Submit the statement
         */
        _controller.submit = () => {
            let _submit = () => {
                let promise = DataService.submit(_controller.data);
                promise.finally(() => _controller.hasNetworkActivity(false));

                return promise;
            };


            _controller.hasNetworkActivity(true);

            //Reference to mediaDrop is set by the directive
            if (_controller.mediaDrop && _controller.mediaDrop.submitMedia) {
                return _controller.mediaDrop.submitMedia()
                    .then(_submit);
            }
            else {
                return _submit();
            }
        };


        /**
         * React on uploading an image
         *
         * @param image_id
         * @param image
         */
        _controller.mediaOnUpload = function(image_id, image) {
            _controller.data.image_id = image_id;
            _controller.data.image = image;
        };

        /**
         * React on removing an images
         */
        _controller.mediaOnRemove = function() {
            delete _controller.data.image;
            delete _controller.data.image_id;
        };

        _controller.getShareURL = () => {
            const redirect_url = encodeURIComponent(`${location.protocol}//${location.hostname}${location.pathname}#commitment=${_controller.data.id}`);
            return encodeURIComponent(`${CTServiceAPIConfig.HOST}/api/v1/pages/${AppConstants.PAGE_ID}/commitments/${_controller.data.id}/share?redirect_url=${redirect_url}`);
        };

        function initStep(step) {
            switch (step) {
                case STEPS.PERSON:
                    break;
                case STEPS.IMAGE:
                    if (_controller.data.image_id) {
                        return initStep(STEPS.STATEMENT);
                    }
                    break;
                case STEPS.STATEMENT:
                    if (_controller.data.message) {
                        return initStep(STEPS.TAGS);
                    }
                    break;
                case STEPS.TAGS:
                    if (!AppConstants.TAGS_ENABLED) {
                        return initStep(STEPS.FINISH);
                    }
                    break;
            }

            _step = step;
        }

        function checkFBData(data, context, itemID) {
            if (context !== 'commitment' && itemID !== 'new') {
                return;
            }

            _controller.hasFbEmail = !!data.email;

            $scope.$applyAsync(() => fetchUserImageFromFacebook()
                .then(() => {
                    if (_controller.hasFbEmail && !AppConstants.ZIP_REQUIRED) {
                        $scope.$applyAsync(_controller.sendCurrentStep);
                    }
                }));
        }

        function fetchUserImageFromFacebook(fb_data) {
            _controller.hasNetworkActivity(true);

            //Create a promise while communication with FB
            return $q((resolve, reject) => {

                //Set the API Call
                FB.api('/me/picture', {
                    width: 1080,
                    height: 1080,
                    fields: 'is_silhouette,url'
                }, (response) => {
                    if (response.data) {
                        resolve(response.data);
                    }
                    else {
                        reject(response);
                    }
                });
            })
                .then((data) => {
                    //If image is no silhouette assign it to the data model
                    if (!data.is_silhouette) {
                        return CTServiceAPI({
                            method: 'POST',
                            url: '/uploaded_images',
                            params: {
                                url: data.url
                            }
                        })
                            .then((data) => {
                                _controller.data.image_id = data.image_id;
                                _controller.data.image = data.image;
                            });
                    }
                })
                .finally(() => _controller.hasNetworkActivity(false));
        }

        (function init() {
            /**
             * Initialize the signup data
             * @type {{person: {}}}
             */
            _controller.reset();


            _SMChannel.subscribe(AppConstants.CHANNEL_SOCIALMEDIA.ACTION_FB_CONNECT, checkFBData);
        }());
    }
];
